module.exports = __webpack_public_path__ + "img/circle9.c2669ae6.svg";